import type { FunctionComponent } from 'react'
import React, { useMemo, useRef } from 'react'
import { useWindowScroll } from 'react-use'

import classnames from 'classnames'

import { Context } from './Head.context'
import styles from './Head.module.scss'
import { isSticking } from './Head.utils'

export const Head: FunctionComponent = ({ children }) => {
  const headRef = useRef<HTMLTableSectionElement>(null)
  const contextValue = useMemo(() => ({ isHead: true }), [])

  useWindowScroll()

  return (
    <thead
      ref={headRef}
      className={classnames(
        styles.container,
        headRef.current && isSticking(headRef.current) && styles.containerSticking
      )}
    >
      <Context.Provider value={contextValue}>{children}</Context.Provider>
    </thead>
  )
}
